import './AddFavorite.scss'
import React from 'react'

const AddFavorite = () => {
    return (
        <div className="add-favorite">
            <i className="fas fa-heart"></i>
        </div>
    )
}

export default AddFavorite
